import { createMsalConfig, AuthClient } from '@ingka-group-digital/people-auth';
import { AZURE_APP_ID, REDIRECT_URI } from 'utils/env';

const tokenScopes = ['User.Read', 'openid', 'profile', 'Group.Read.All'];
const config = createMsalConfig(AZURE_APP_ID, REDIRECT_URI);
const authClient = AuthClient(config, tokenScopes);

export { authClient, config, tokenScopes };
